import {
  ChangeDetectionStrategy,
  Component,
  Type,
  ViewEncapsulation,
} from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/kendo/form-field';
import { FormlyFieldCheckbox } from '@ngx-formly/kendo/checkbox';

interface CheckboxProps extends FormlyFieldProps {
  labelAfter?: boolean;
}

export interface FormlyCheckboxFieldConfig
  extends FormlyFieldConfig<CheckboxProps> {
  type: 'checkbox' | Type<FormlyFieldCheckbox>;
}

@Component({
  selector: 'gk-formly-field-kendo-checkbox',
  template: `
    <input
      type="checkbox"
      kendoCheckBox
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
    @if (props.label && props.labelAfter === true) {
      <label [for]="id" class="k-checkbox-label">
        {{ props.label | translate }}
        <span
          *ngIf="props.required && props.hideRequiredMarker !== true"
          aria-hidden="true"
          class="k-required"
          >*</span
        >
      </label>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .k-form formly-field-kendo-checkbox .k-label {
        display: inherit;
      }
    `,
  ],
  standalone: false,
})
export class FormlyFieldKendoCheckboxComponent extends FieldType<
  FieldTypeConfig<CheckboxProps>
> {
  override defaultOptions = {
    props: {
      labelAfter: true,
    },
  };
}
